import React, { FC } from 'react';
import Modal from '@common/modal';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';

import classnames from 'classnames/bind';
import styles from './resultModal.module.scss';
const cx = classnames.bind(styles);

const SuccessContents = () => {
  return (
    <>
      <strong className={cx('title')}>역검 유효기간이 연장되었습니다.</strong>

      <p className={cx('desc')}>
        서비스 이용 기간 동안 역검 응시/결과 정보를
        <br />
        자유롭게 확인하실 수 있습니다.
      </p>
    </>
  );
};

const ErrorContents = () => {
  return (
    <>
      <strong className={cx('title')}>역검 유효기간 연장에 실패했습니다.</strong>

      <p className={cx('desc')}>
        이와 같은 메시지를 확인한 회원님께서는
        <br />
        잡다로 문의주시기 바랍니다.
      </p>
      <a href={`mailto:${JOBDA_SUPPORT_EMAIL}`} className={cx('link')}>
        {JOBDA_SUPPORT_EMAIL}
      </a>
    </>
  );
};

const AlreadyAgreedContents = () => {
  return <strong className={cx('title')}>이미 동의하셨습니다.</strong>;
};

export type ContentType = 'SUCCESS' | 'ERROR' | 'ALREADY_AGREED';

interface IResultModalProps {
  visible: boolean;
  contentType: ContentType;
}

const getContents = (type: ContentType) => {
  switch (type) {
    case 'ALREADY_AGREED':
      return <AlreadyAgreedContents />;
    case 'SUCCESS':
      return <SuccessContents />;
    case 'ERROR':
    default:
      return <ErrorContents />;
  }
};

const ResultModal: FC<IResultModalProps> = ({ visible, contentType }) => {
  const contents = getContents(contentType);

  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layer')}>
        {contents}
        <a className={cx('btn')} role={'button'} onClick={() => window.close()}>
          확인
        </a>
      </div>
    </Modal>
  );
};

export default ResultModal;
